import { Card, DataTable, type Column } from '@platform/design-system';
import { usePageContext } from '../usePageContext.ts';
import styles from './Statistics.module.css';

export type StatisticsTableProps<Row> = {
  title: string;
  help?: string;
  columns: readonly Column<Row>[];
  rows: readonly Row[];
  rowKey: (row: Row) => string;
  emptyTitle: string;
};

export const StatisticsTable = <Row,>({
  title,
  help,
  columns,
  rows,
  rowKey,
  emptyTitle,
}: StatisticsTableProps<Row>) => {
  const { tableLabels } = usePageContext();
  return (
    <Card title={title}>
      {help === undefined ? null : <p className={styles['muted']}>{help}</p>}
      <DataTable
        columns={columns}
        rows={rows}
        rowKey={rowKey}
        emptyTitle={emptyTitle}
        labels={tableLabels}
        responsive="cards"
      />
    </Card>
  );
};
